var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.9c-.7-.2-1.1-.8-1-1.4.1-.6.8-1.1 1.5-1 .7.1 1.2.6 1.2 1.3 0 .2 0 .3-.1.4-.2.6-.9.9-1.6.7zm-6-5.2V8c1.7.1 3.6 1.4 5 2.3.2.1.4.3.6.4h-5.6zm-.9 0H6.3L4.8 8.9c1.9-.5 3.8-.8 5.8-.9v2.7zm-3 4.4c-.2.6-1 .9-1.6.8-.7-.2-1.1-.8-1-1.4.1-.6.8-1.1 1.5-1 .7.1 1.2.6 1.2 1.3 0 0-.1.2-.1.3zm14.9-3.8l-3.3-.6c-1.1 0-4.4-3.4-7.7-3.6h-1c-3.6.2-7 1-10.3 2.4-.1.1-.1.2-.2.3 0 .1 0 .3.1.4l.7.9-.8 2.7c-.1.3 0 .6.3.9l.3.3c.2 0 .4.1.7.1h2.6c.2 1 1.2 1.8 2.4 1.8 1.1 0 2.1-.8 2.4-1.8h6.8c.2 1 1.2 1.8 2.4 1.8 1.1 0 2.1-.8 2.4-1.8H23c.5 0 1-.4 1-.9V13c0-.8-.6-1.6-1.5-1.7z"
  })));
}

export default SvgCar;